import {
  ClientInfoItem,
  ClientUser,
  ConfigClientObjectDB,
  UserClient,
  UserClientObjectDB
} from '../models/client-item.models';
import { GeoPosition } from '@shared/models/coordinates.models';
import { MapAddressDetails, MapGeoPositionAddressDetails } from '../models/map.models';

export function getClientInfoAddress(clientInfo: ClientInfoItem | UserClient): string {
  return getMapGeoPositionAddressInfo(getClientMapGeoPositionAddressDetails(clientInfo));
}

export function getClientMapGeoPositionAddressDetails(
  clientInfo: ClientInfoItem | UserClient
): MapGeoPositionAddressDetails {
  return {
    address: clientInfo.addressInfo,
    position: clientInfo.position
  };
}

export function getMapGeoPositionAddressInfo(mapGeoPositionAddressDetails: MapGeoPositionAddressDetails): string {
  const position: GeoPosition = mapGeoPositionAddressDetails.position;
  const address: MapAddressDetails = mapGeoPositionAddressDetails.address;
  if (address.addressLine && address.country && address.city) {
    const state: string = address.state ? `${address.state}, ` : '';
    return `${address.country}, ${state}${address.city}, ${address.addressLine}`;
  }
  if (address.city) {
    return `${address.city}, ${position.lat} ${position.lng}`;
  }
  return `${position.lat} ${position.lng}`;
}

export function mapClientPositionToPosition(config: ConfigClientObjectDB | UserClientObjectDB): GeoPosition {
  return {
    lat: Number(config.address.lat),
    lng: Number(config.address.long)
  };
}

export function mapClientAddressToMapAddress(config: ConfigClientObjectDB | UserClientObjectDB): MapAddressDetails {
  return {
    city: config.address.city,
    postalCode: config.address.postalCode,
    country: config.address.country,
    addressLine: config.address.addressLine,
    state: config.address.state
  };
}

export function filterVisibleUsesInClient(
  clientList: ClientUser[],
  currentUserEmail: string,
  adminUsersEmails: string[]
): ClientUser[] {
  return clientList.filter((user: ClientUser) => {
    if (currentUserEmail === user.email) {
      return true;
    }

    return !adminUsersEmails.includes(user.email) && !user.isSuperChemicalResearcher && !user.isSuperAdmin;
  });
}
